import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { LogElement } from '@models/order';
import { FormatData } from '@classes/format-data';

@Component({
  selector: 'app-last-editor-field',
  templateUrl: './last-editor-field.component.html',
  styleUrls: ['./last-editor-field.component.css'],
})
export class LastEditorFieldComponent {
  @Input() orderForm: FormGroup;

  get sortedLogs(): LogElement[] {
    const logs = this.orderForm?.value?.log;
    if (!logs?.length) {
      return [];
    }
    return logs
      .slice()
      .sort(
        (a, b) =>
          new Date(b.date ?? 0).getTime() - new Date(a.date ?? 0).getTime()
      );
  }

  get latestLog(): LogElement | null {
    return this.sortedLogs[0] ?? null;
  }

  get displayInitials(): string {
    if (this.latestLog?.initials) {
      return this.latestLog.initials;
    }
    return this.sortedLogs.find((log) => log.initials)?.initials ?? '';
  }

  get hasLogs(): boolean {
    return this.sortedLogs.length > 0;
  }

  formatLogItem(item?: string): string {
    return FormatData.formatLogItem(item);
  }
}
